import { Textarea as TrussTextarea } from "@trussworks/react-uswds";
import cn from "classnames";

// types
import { TextareaProps as TrussTextareaProps } from "@trussworks/react-uswds/lib/components/forms/Textarea/Textarea";

// styles
import styles from "./Textarea.module.scss";

type TextareaProps = {
  label?: string;
  rootClassName?: string;
  inputClassName?: string;
} & TrussTextareaProps &
  JSX.IntrinsicElements["textarea"];

export default function Textarea(props: TextareaProps) {
  const { label, rootClassName, inputClassName, ...rest } = props;

  const rootClasses = cn(styles["textarea-root"], {
    [rootClassName!]: rootClassName,
  });

  const inputClasses = cn(styles["textarea"], {
    [inputClassName!]: inputClassName,
  });

  return (
    <div className={rootClasses}>
      {label && <label htmlFor={props.id}>{label}</label>}
      <TrussTextarea className={inputClasses} {...rest} />
    </div>
  );
}
